import inspectionQueueDB from '@mobile/db/inspections';
import inspectionService from '@mobile/services/inspection';

export default {
    namespaced: true,

    state: getDefaultState(),

    getters: {
        queue: (state) => state.queue,
        queue_count: (state) => state.queue.length,
        done: (state) => state.done,
        has_prev_page: (state) => (!!state.prev_page_url),
        has_next_page: (state) => (!!state.next_page_url),
        loading: (state) => state.loading,
        initial_loading: (state) => state.initial_loading,
    },

    actions: {
        async sendQueue({ dispatch, rootGetters }) {
            if (rootGetters['authentication/user']) {
                await inspectionQueueDB.sendQueueForUser(rootGetters['authentication/user'].id);
                dispatch('loadQueueFromDB');
            }
        },
        async loadQueueFromDB({ state, rootGetters }) {
            if (rootGetters['authentication/user']) {
                state.queue = await inspectionQueueDB.getQueueForUser(rootGetters['authentication/user'].id);
            }
        },

        async query({ state, commit }, payload = {}) {
            if (!payload.url) {
                commit('resetDone');
                state.initial_loading = true;
            }

            commit('startLoading');

            const response = await inspectionService.getAll(payload.url, payload.filters, true);

            state.done = state.done.concat(response.resources);

            state.prev_page_url = response.prev_page_url;
            state.next_page_url = response.next_page_url;

            state.loading = false;

            if (state.initial_loading) {
                state.initial_loading = false;
            }

            console.log('end loading');
        },
        async loadMore({ state, dispatch }, payload) {
            dispatch('query', { url: state.next_page_url, filters: payload.filters });
        },
    },

    mutations: {

        reset(state) {
            Object.assign(state, getDefaultState());
        },

        resetDone(state) {
            state.done = [];
        },

        startLoading(state) {
            state.loading = true;
            console.log('loading');
        },

    },

};

function getDefaultState() {
    return {
        queue: [],
        done: [],
        next_page_url: null,
        prev_page_url: null,
        loading: true,
        initial_loading: true,
    };
}
